import React,{ useState, useEffect } from 'react';
import { Link } from 'react-router-dom';
import ipCheck from "../sharecomponents/ipCheck";
import envConfig from '../../config/env';

function ManagerSlideBar(props) {
  const [IpCheck, setIpCheck] = useState('');
  useEffect(() => {
    ipCheck().then((data)=> setIpCheck(data) );  
  });
  
    const guideURL = '/doc/user_guide.pdf';
    const cid = props.match.params.cid;
    return (
        
          <ul className="navbar-nav bg-gradient-primary sidebar sidebar-dark accordion" id="accordionSidebar">

              <Link className="sidebar-brand d-flex align-items-center justify-content-center" to={`/managerweb/${cid}`}>
                <div className="img-fluid-2">
                  <img className="img-fluid" src='/image/1111.png' alt='1111' />
                </div>
              </Link> 

              <hr className="sidebar-divider my-0" /> 

              <li className="nav-item active">
                  <h6 className="m-0 font-weight-bold text-white">客製化網頁</h6>
              </li>

              <hr className="sidebar-divider" />   
              <div className="sidebar-heading">
              <h6 className="m-0 font-weight-bold text-white">網站設定</h6>
              </div>

              <li className="nav-item">
                <a className="nav-link collapsed" href="/#" data-toggle="collapse" data-target="#collapseTwo" aria-expanded="true" aria-controls="collapseTwo">
                  <i className="fas fa-fw fa-cog"></i>
                  <span>通用設定</span>
                </a>
                <div id="collapseTwo" className="collapse show" aria-labelledby="headingTwo" data-parent="#accordionSidebar">
                  <div className="bg-white py-2 collapse-inner rounded">
                    {/*<h6 className="collapse-header">通用設定</h6>
                    <a className="collapse-item" href="/#" onClick={()=>loginHandler(props,'setting')}>網站通用設定</a>*/}
              
                    <Link className="collapse-item" to={{pathname:`/managerweb/${cid}/setting`, state: { detail: cid }}}>網站通用設定</Link>
                  </div>
                </div>
              </li>

              {envConfig.DevMode &&
              <li className="nav-item">
                <a className="nav-link collapsed" href="/#" data-toggle="collapse" data-target="#collapseUtilities" aria-expanded="true" aria-controls="collapseUtilities">
                  <i className="fas fa-fw fa-wrench"></i>
                  <span>模板設定</span>
                </a>
                <div id="collapseUtilities" className="collapse" aria-labelledby="headingUtilities" data-parent="#accordionSidebar">
                  <div className="bg-white py-2 collapse-inner rounded">
                    {/* <h6 className="collapse-header">模板設定</h6>這一行原本有註解，因為區塊要先注解，所以先留個文字提醒自己 */}
                    <Link className="collapse-item" to={{pathname:`/managerweb/${cid}/template1`, state: { detail: cid }}}>模板樣式 =1=</Link>
                    <Link className="collapse-item" to={{pathname:`/managerweb/${cid}/template2`, state: { detail: cid }}}>模板樣式 =2=</Link>
                    <Link className="collapse-item" to={{pathname:`/managerweb/${cid}/template3`, state: { detail: cid }}}>模板樣式 =3=</Link> 
                    <Link className="collapse-item" to={{pathname:`/managerweb/${cid}/template4`, state: { detail: cid }}}>模板樣式 =4=</Link>
                    <Link className="collapse-item" to={{pathname:`/managerweb/${cid}/template5`, state: { detail: cid }}}>模板樣式 =5=</Link>
                    <Link className="collapse-item" to={{pathname:`/managerweb/${cid}/template6`, state: { detail: cid }}}>模板樣式 =6=</Link>
                  </div>
                </div>
              </li>
               }
              {/* 有版權問題先關閉不讓客戶下載使用 榜定辦公室IP才開通 */}
              { IpCheck==="UGIT" &&
              <li className="nav-item">
                <a className="nav-link collapsed" href="/#" data-toggle="collapse" data-target="#collapsePictures" aria-expanded="true" aria-controls="collapsePictures">
                  <i className="fas fa-fw fa-images"></i>
                  <span>參考圖庫</span>
                </a>
                {/* <div id="collapsePictures" className="collapse show" aria-labelledby="headingTwo" data-parent="#accordionSidebar">
                  <div className="bg-white py-2 collapse-inner rounded">
                    <h6 className="collapse-header">參考圖庫</h6>  這一行原本有註解，因為圖庫整區塊要先注解，所以先留個文字提醒自己
                    <Link className="collapse-item" to={{pathname:`/managerweb/${cid}/imageGallery`, state: { detail: cid }}}>圖庫</Link>                                    
                  </div>
                </div> */}

                <div id="collapsePictures" className="collapse show" aria-labelledby="headingTwo" data-parent="#accordionSidebar">
                  <div className="bg-white py-2 collapse-inner rounded">                   
                    <Link className="collapse-item" to={{pathname:`/managerweb/${cid}/imageGallery2`, state: { detail: cid }}}>新圖庫</Link>                                    
                  </div>
                </div>
              </li>  
              
              }

              <hr className="sidebar-divider d-none d-md-block" />

              <li className="nav-item">
                <a className="nav-link collapsed" href="/#" data-toggle="collapse" data-target="#collapseDocument" aria-expanded="true" aria-controls="collapseDocument">
                  <i className="fas fa-fw fa-file"></i>
                  <span>操作手冊</span>
                </a>
                <div id="collapseDocument" className="collapse show" aria-labelledby="headingTwo" data-parent="#accordionSidebar">
                  <div className="bg-white py-2 collapse-inner rounded">
                    <a className="collapse-item" target="_blank" rel="noopener noreferrer" href={guideURL}>操作手冊</a>                    
                  </div>
                </div>
              </li>

              <hr className="sidebar-divider d-none d-md-block" />

             
        </ul>    
        
    )

}

export default ManagerSlideBar;